import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Card.module.css';

function Card({ lien, image, children }) {

    if (image && !image.startsWith(process.env.REACT_APP_API_URL_PUBLIC)) {
        image = process.env.REACT_APP_API_URL_PUBLIC + image;
    }
    return (
        <div className={styles.card} style={{ backgroundImage: `url(${image})` }}>
            <div className={styles.cardOverlay}>
                <Link to={lien} className={styles.cardLink}></Link>
                <div className={styles.cardContent}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Card;
